import { dataAiText } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAiText = /*#__PURE__*/createIcon(dataAiText)
export default IconAiText
